import { VisitorPlaceService } from './../../../../event-calendar/services/visitor.place.service';
import { IPlaceDetailsModalData } from './../../../../place-calendar/components/place.details.modal/place.details.modal.provider';
import { VisitorPlace } from './../../../models/visitor.place';
import { EventDetailsStyle } from '../../../models/visitor.custom.settings';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/common/components/base.component';
import { ModalService } from 'src/app/common/services/modal/modal.service';
import { FancyEventDetailsModalComponent } from 'src/app/modules/event-calendar/components/event.details.modal/fancy.event.details.modal/fancy.event.details.modal.component';
import { VisitorEvent } from '../../../models/visitor.event';
import { IEventDetailsModalData } from 'src/app/modules/event-calendar/components/event.details.modal/event.details.modal.provider';
import { FavoriteCustomEvent } from '../../../models/favorite.custom.event';
import { FancyPlaceDetailsModalComponent } from 'src/app/modules/place-calendar/components/place.details.modal/fancy.place.details.modal/fancy.place.details.modal.component';
import { inject } from '@angular/core';
import { KeywordService } from '../../../services/keyword.service';
import { Subscription } from 'rxjs';

export class VisitorCardBaseComponent extends BaseComponent {
  item: VisitorEvent | VisitorPlace;
  allItems: VisitorEvent[] = [];
  detailsPageStyle: EventDetailsStyle;
  favCustomEvents: FavoriteCustomEvent[] = [];

  placeService = inject(VisitorPlaceService);
  keywordService = inject(KeywordService);

  // for highlight search keywords
  keywordSubscription: Subscription;
  keyword: string;

  searchFields: string[] = [];

  constructor(public activatedRoute: ActivatedRoute, public modalService: ModalService) {
    super({ activatedRoute });
  }

  get isSearchName(): boolean {
    return this.searchFields.length === 0 || this.searchFields.includes('name');
  }

  get isSearchAddress() {
    return this.searchFields.includes('address');
  }

  get isSearchCategory() {
    return this.searchFields.includes('category');
  }

  showDetails() {
    // promotion image is added in infinite.scroll.component.ts
    if (this.item.socialName === 'promotion') {
      const link = this.item.hostLink?.startsWith('http')
        ? this.item.hostLink
        : `https://${this.item.hostLink}`;
      window.open(link, '_blank');
      return;
    }

    if (this.getItemType() === 'event') {
      this.modalService.show({
        component: FancyEventDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentEvent: this.item,
          allEvents: this.allItems,
        } as IEventDetailsModalData,
      });
    } else {
      this.modalService.show({
        component: FancyPlaceDetailsModalComponent,
        panelClass: 'ig-modal-w-full',
        data: {
          currentPlace: this.item,
        } as IPlaceDetailsModalData,
      });
    }

    // this.onClick.emit();
  }

  getItemType() {
    return this.item.startTime ? 'event' : 'place';
  }

  getDisplayCategory(item: VisitorPlace) {
    return this.placeService.getDisplayCategory(item);
  }
}
